import { Card } from '../components/Card.js';

export const OfflinePage = () => {
  return (
    <main className="mx-auto max-w-prose p-4">
      <Card>
        <div className="text-center">
          <h1 className="text-xl font-medium text-text">You're Offline</h1>
          <p className="mt-2 text-text-secondary">Your device is offline at the moment.</p>
          <p className="mt-4 text-sm text-text-secondary">
            Please try again when you're back online.
          </p>
        </div>
      </Card>
    </main>
  );
};
